module.exports = __webpack_public_path__ + "img/nicaragua.181cbb4.webp";